import { defineStore } from "pinia";
import { useSystemStore } from "./system";
import { GET_BI, GET_BI_DETAIL, SEND_MAIL } from "./lib/apis";

export const useBIStore = defineStore("bi", {
  state: () => ({
    detailsData: {
      header: [],
      data: [],
      hideColumns: [],
      filters: {},
    },
    isAutoplay: false,
    reqDados: {
      filter: "",
      filterSel: "",
      idDashboardProvide: "",
      idDashboardConditions: false,
      idDashboardDef: "",
      path: "",
    },
    showBiExport: false,
    showBiConfig: false,
  }),

  actions: {
    setDetailsData(payload) {
      this.detailsData = payload;
    },
    setReqDados(payload) {
      if (!payload.idDashboardConditions) {
        payload.idDashboardConditions = null;
      }
      this.reqDados = payload;
    },
    setAutoplay(payload) {
      if (typeof payload != "boolean") return;
      this.isAutoplay = payload;
    },
    setBiConfig(payload) {
      if (typeof payload != "boolean") return;
      this.showBiConfig = payload;
    },
    setBiExport(payload) {
      if (typeof payload != "boolean") return;
      this.showBiExport = payload;
    },
    getBi(params) {
      return new Promise((resolve, reject) => {
        const systemStore = useSystemStore();
        // faz a chamada
        systemStore
          .post(
            { url: GET_BI, data: { ...params }, responseType: "text" },
            { root: true }
          )
          // caso a chamada seja bem sucedida
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },

    /*
      Chamada para carregar detalhes do BI
    */
    getBiDetails(params) {
      return new Promise((resolve, reject) => {
        const systemStore = useSystemStore();
        // faz a chamada
        systemStore
          .post(
            { url: GET_BI_DETAIL, data: { ...params }, responseType: "json" },
            { root: true }
          )
          // caso a chamada seja bem sucedida
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },

    /*
      Chamada para enviar email
    */
    sendMail(params) {
      return new Promise((resolve, reject) => {
        const systemStore = useSystemStore();
        // faz a chamada
        systemStore
          .post({ url: SEND_MAIL, data: { ...params }, responseType: "text" })
          // caso a chamada seja bem sucedida
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },

    /*
      Função para alterar o BI headers
    */
    toggleBIHeaders({ commit, state }) {
      if (state.showBIHeaders === false) {
        commit("ENABLE_BI_HEADERS");
      } else {
        commit("DISABLE_BI_HEADERS");
      }
    },
  },
});
